<script>
	import { injectAnalytics } from '@vercel/analytics/sveltekit'
	import { onMount } from 'svelte';
	import { components, viewport } from '$lib/stores/shared.svelte.js'
	import favicon from '$lib/images/favicon.svg';
	import Header from '$components/header.svelte';
	import Footer from '$components/footer.svelte';
	import DebugTool from '$components/debug.svelte';
	import '$css';
	let { children, data } = $props();
	let minHeight = $derived( viewport.vh - components.headH - components.footH );

	  function updateViewport() {
		viewport.vh = window.innerHeight;
		viewport.vw = window.innerWidth;
		viewport.scrollX = window.scrollX;
		viewport.scrollY = window.scrollY;
	};

	onMount( () => {
		window.addEventListener('resize', updateViewport);
		updateViewport();
		return () => window.removeEventListener('resize', updateViewport)
	});
</script>

	{#if data.debug}<DebugTool />{/if}
<svelte:window 
	bind:innerHeight={viewport.vh} 
	bind:innerWidth={viewport.vw} 
	bind:scrollX={viewport.scrollX}
	bind:scrollY={viewport.scrollY}
	/>

<svelte:head>
	<meta name="format-detection" content="telephone=no" />
	<link rel="icon" href={favicon} />
	<title>Kinetic Design</title>
</svelte:head>
<svelte:body style:overflow={components.navOpen ? 'hidden' : 'auto'} />
<Header />
<main 
	style="
		width: {viewport.vw}px;
		min-height: {minHeight}px
		"
	bind:clientWidth={components.mainW}
	>
	{@render children()}
</main>
<Footer />

<style>
main {
	overflow: hidden;
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
    flex-grow: 1;
	justify-content: flex-start;
	background-color: var(--main-bg-color);
}


/* Mobile Breakpoint */

@media (max-width: 768px) {

	/* main {
		padding: 0 clamp(0.6875rem, -1.375rem + 1.7188vw, 3.5rem);
	} */
}


</style>